import { render, staticRenderFns } from "./ConceptProductTable.vue?vue&type=template&id=f749c71a&scoped=true&"
import script from "./ConceptProductTable.vue?vue&type=script&lang=js&"
export * from "./ConceptProductTable.vue?vue&type=script&lang=js&"
import style0 from "./ConceptProductTable.vue?vue&type=style&index=0&id=f749c71a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f749c71a",
  null
  
)

export default component.exports